import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './Work.scss';

import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../client';
import Projects from '../../components/Projects';
import { useSkillsData } from '../../constants/useSkillsData';

const Work = () => {
  // states
  const [activeFilter, setActiveFilter] = useState('ALL WORK');
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });
  const [works, setWorks] = useState([]);
  const [filterWork, setFilterWork] = useState([]);

  const skills = useSkillsData();

  // Effects hook
  useEffect(() => {
    const query = '*[_type == "works"]';

    client.fetch(query).then((data) => {
      setWorks(data);
      setFilterWork(data);
    });
  }, []);

  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    setAnimateCard([{ y: 100, opacity: 0 }]);
    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }]);

      if (item === 'ALL WORK') {
        setFilterWork(works);
      } else {
        setFilterWork(works.filter((work) => work.tags.includes(item)));
      }
    }, 500);
  };

  return (
    <>
      <h2 className="head-text">
        <span>Selected</span> Works
      </h2>
      <h3 className="subhead-text">Projects</h3>

      <div className="app__work-filter">
        {[
          'ALL WORK',
          'WEB APPS',
          'TRAVEL & HOSPITALITY',
          'REAL ESTATE',
          'FOOD & RESTAURANTS',
          'SOCIAL & COMMUNITY',
        ].map((item, index) => (
          <>
            <div
              key={item}
              onClick={() => handleWorkFilter(item)}
              className={`app__work-item app__flex p-text ${
                activeFilter === item ? 'item-active ' : ''
              }`}
            >
              {item}
            </div>
          </>
        ))}
      </div>

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-protfolio"
      >
        {filterWork?.map((work) => {
          return (
            <Projects
              key={work._id}
              id={work._id}
              imgUrl={work.imgUrl}
              name={work.name}
              projectLink={work.projectLink}
              codeLink={work.codeLink}
              title={work.title}
              description={work.description}
              tags={work.tags[0]}
              skillsTag={work.skills}
              skills={skills}
            />
          );
        })}
      </motion.div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Work, 'app__works'),
  'work',
  'app__primarybg',
);
